import { createBrowserRouter } from "react-router";
import App from "./App.tsx";
import { WebSSH } from "./Pages/WebSSH.tsx";
import { ErrorElement } from "./components/ErrorElement.tsx";
import { errorMap } from "./errorMap.tsx";
import RemoteRoot from "@mittwald/flow-remote-react-components/RemoteRoot";
import { Terminal } from "./Pages/Terminal.tsx";

export const routes = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorElement errorMap={errorMap} />,
    children: [
      {
        path: "/",
        element: (
          <RemoteRoot>
            <WebSSH />
          </RemoteRoot>
        ),
      },
      {
        // todo: error component
        errorElement: <p>Error</p>,
        path: "/terminal/:sessionId",
        element: <Terminal />,
      },
    ],
  },
]);
